// 微信api
const WeixinApi = {
  // 分享
  share: function (options, successcb, errorcb) {
    var setShare = function () {
      if (options.description && options.description.length > 30) {
        options.description = options.description.substr(0, 27) + '...'
      }
      var data = {
        title: options.title,
        link: options.webpageURL,
        imgUrl: options.iconURL,
        desc: options.description
      }
      // window.wx.onMenuShareAppMessage(data)
      // window.wx.onMenuShareTimeline(data)
      window.wx.updateAppMessageShareData(data)
      window.wx.updateTimelineShareData(data)
    }
    if (!window.wx) {
      this._delayList.push(setShare)
      return false
    }
    window.wx.ready(function () {
      setShare()
    })
  },
  // 关闭
  close: function (options, successcb, errorcb) {
    console.log('wx.close')
    window.wx.closeWindow()
  },
  // 上传图片
  uploadImg: function (options, successcb, errorcb) {
    window.wx.uploadImage({
      localId: options.localId,
      isShowProgressTips: 0,
      success: function (res) {
        var serverId = res.serverId
        successcb({ imgId: serverId })
      }
    })
  },
  // 选择图片
  chooseImage: function (options, successcb, errorcb) {
    window.wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      success: function (res) {
        var localIds = res.localIds
        if (localIds.length > 0) {
          successcb({ imgId: localIds[0] })
        } else {
          console.log(res)
          errorcb()
        }
      }
    })
  },
  // 跳出浏览器打开
  openBrowser: function (options, successcb, errorcb) {
    window.location = options.uri
  }
}
export default WeixinApi



// WEBPACK FOOTER //
// ./src/environment/weixin_api.js